var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.672,
    height: 12,
    viewBox: "0 0 10.672 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#43425d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.328,6A.683.683,0,0,1,8,6.672a.62.62,0,0,1-.2.464.659.659,0,0,1-.472.192H6V8.672a.62.62,0,0,1-.2.464.659.659,0,0,1-.472.192.656.656,0,0,1-.656-.656V7.328H3.328a.656.656,0,0,1-.656-.656A.659.659,0,0,1,2.864,6.2.62.62,0,0,1,3.328,6H4.672V4.672A.659.659,0,0,1,4.864,4.2.62.62,0,0,1,5.328,4,.683.683,0,0,1,6,4.672V6Zm3.136-3.136a.643.643,0,0,1,.208.464V10a1.994,1.994,0,0,1-2,2H2a1.928,1.928,0,0,1-1.416-.584A1.928,1.928,0,0,1,0,10V2A1.928,1.928,0,0,1,.584.584,1.928,1.928,0,0,1,2,0H7.328a.651.651,0,0,1,.48.192Zm-1.408.464L7.328,1.616v.72a.953.953,0,0,0,.3.7.971.971,0,0,0,.712.3Zm-.384,7.344a.62.62,0,0,0,.464-.2A.659.659,0,0,0,9.328,10V4H8.336A1.6,1.6,0,0,1,7.16,3.512a1.6,1.6,0,0,1-.488-1.176V1.328H2a.646.646,0,0,0-.472.2.646.646,0,0,0-.2.472v8a.646.646,0,0,0,.2.472.646.646,0,0,0,.472.2Zm2,.128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAdd);
export default __webpack_public_path__ + "static/media/document-add.c26eec88e722854b67f73cd6a312b69c.svg";
export { ForwardRef as ReactComponent };